import { useCancellation } from 'hooks/cancellation/useCancellation';

import { InfoBlock } from './InfoBlock';
import { Title } from './Title';

import s from './CancellationPolicy.module.css';

export const CancellationPolicy = () => {
  const { cancellationPolicyText } = useCancellation();

  return (
    <InfoBlock as="section">
      <Title>Cancellation Policy</Title>
      <div className={s.displayLineBreaks}>{cancellationPolicyText}</div>
    </InfoBlock>
  );
};
